import React from 'react';
import {Divider} from 'wix-ui-tpa/Divider';
import {ShippingSection} from '../ShippingSection/ShippingSection';
import {TotalsSection} from '../TotalsSection/TotalsSection';
import s from './Layout.scss';
import {ProductLineItems} from '../ProductLineItemsSection/ProductLineItems';

export enum LayoutDataHook {
  root = 'LayoutDataHook.root',
  itemsSection = 'LayoutDataHook.itemsSection',
  totalsSection = 'LayoutDataHook.totalsSection',
  shippingSection = 'LayoutDataHook.shippingSection',
  productLineItem = 'LayoutDataHook.productLineItem',
}

export const Layout = () => {
  return (
    <div className={s.root} data-hook={LayoutDataHook.root}>
      <Divider className={s.divider} />
      <div className={s.box}>
        <section className={s.lineItemsSection} data-hook={LayoutDataHook.itemsSection}>
          <ProductLineItems />
        </section>
        <Divider className={s.divider} />
        <section className={s.totalsSection} data-hook={LayoutDataHook.totalsSection}>
          <TotalsSection />
        </section>
      </div>
      <div className={`${s.box} ${s.shippingBox}`}>
        <section className={s.shippingSection} data-hook={LayoutDataHook.shippingSection}>
          <ShippingSection />
        </section>
      </div>
    </div>
  );
};
